import { Button } from "@base-ui/react"
import { cartStore } from "@features/auth/tess-cart.store"
import { authStore } from "@features/auth/tess-session.store"
import { flyingCarpetStore } from "@features/flying-carpet/flying-carpet.store"
import { RiShoppingCart2Fill } from "@remixicon/react"
import { observer } from "mobx-react-lite"

export function UserMenu() {
  return (
    <div className="flex gap-3">
      <AuthButton />
      <CartButton />
    </div>
  )
}

const AuthButton = observer(() => {
  const label = authStore.isAuthenticated ? authStore.account?.email || "Account" : "Sign In"

  return (
    <Button
      onClick={() => {
        if (authStore.isAuthenticated) {
          flyingCarpetStore.open("account")
        } else {
          flyingCarpetStore.open("signin")
        }
      }}
    >
      {label}
    </Button>
  )
})

const CartButton = observer(() => {
  const count = cartStore.itemCount
  return (
    <Button className="relative" onClick={() => flyingCarpetStore.open("cart")}>
      <RiShoppingCart2Fill size="18px" />
      {count > 0 && (
        <div className="absolute top-[-0.3em] right-[-0.4em] bg-orange type-ui-chip size-[1.3em] rounded-full inline-flex items-center justify-center text-center">
          {count}
        </div>
      )}
    </Button>
  )
})
